<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div class="table-container">
          <div class="scroll-wrapper">
            <b-table
              responsive
              :items="Items"
              :fields="fields"
              thead-class="hidden_header"
              class="custom-table"
            >
              <!-- <template
                #cell(icon)="data"
                class="icon"
              >
                <b-img
                  :src="require('@/assets/images/icons/' + data.value + '.png')"
                  height="32px"
                />
              </template>
              <template
                #cell(lastupdate)="data"
                class="icon"
              >
                <span style="color: #46E0E5;text-shadow: 0 0 4px #46E0E5;">
                  {{ data.value }}
                </span>
              </template>
              <template #cell(event)="data">
                <span style="color: #46E0E5;text-shadow: 0 0 4px #46E0E5;">
                  {{ data.value }}
                </span>
              </template>
              <template #cell(event_status)="data">
                <b-badge
                  :variant="event_status[1][data.value]"
                  style="font-size: 13px;"
                >
                  {{ event_status[0][data.value] }}
                </b-badge>
              </template> -->

              <!-- <template #cell(row_num)="data">
                {{ data.index + 1 }}
              </template> -->
              <!-- <template #cell(approval_name)="data">
                  {{ data.item.approval_name }}
                </template> -->
              <template #cell(filepath)="data">
                <!-- v-b-modal="'Live2'"
                  @click="$refs.vdopath.streamLive(data.item.video_path)" -->
                <b-link
                  v-b-modal="'Incidence3'"
                  @click="$refs.incidentpath.incidentDetail2(data.item.wid, data.item.tid, data.item.camid)"
                >
                  <b-img
                    :src="data.item.filepath"
                    height="160px"
                  />
                </b-link>
              </template>
              <template #cell(live)="data">
                <!-- :to="{ path:`/datatraffic-detail?id=${data.item.id}` }" -->
                <b-link
                  v-b-modal="'Incidence3'"
                  @click="$refs.incidentpath.incidentDetail2(data.item.wid, data.item.tid, data.item.camid)"
                >
                  <b-img
                    title="กดเพื่อดูรายละเอียด"
                    height="25px"
                    src="@/assets/images/icons/info.png"
                  />
                </b-link>
              </template>
            </b-table>

            <b-table
              responsive
              :items="Items"
              :fields="fields"
              thead-class="hidden_header"
              class="custom-table"
            >
              <template #cell(filepath)="data">
                <b-link
                  v-b-modal="'Incidence3'"
                  @click="$refs.incidentpath.incidentDetail2(data.item.wid, data.item.tid, data.item.camid)"
                >
                  <b-img
                    :src="data.item.filepath"
                    height="160px"
                  />
                </b-link>
              </template>
              <template #cell(live)="data">
                <b-link
                  v-b-modal="'Incidence3'"
                  @click="$refs.incidentpath.incidentDetail2(data.item.wid, data.item.tid, data.item.camid)"
                >
                  <b-img
                    title="กดเพื่อดูรายละเอียด"
                    height="25px"
                    src="@/assets/images/icons/info.png"
                  />
                </b-link>
              </template>
            </b-table>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- <hr style="border-top: 1px solid #ffffff; margin:0"> -->
    <Live
      ref="vdopath"
    />
    <Incidence2
      ref="incidentpath"
      @fetch="getSemEvent()"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BImg, BLink,
  // BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import Live from './LiveRTSPvideo2.vue'
import Incidence2 from './IncidenceModal3.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    // BButton,
    BImg,
    BLink,
    // BBadge,

    Live,
    Incidence2,
  },
  data() {
    return {
      items: [],
      fields: [
        // {
        //   key: 'id',
        //   label: 'ลำดับ',
        //   class: 'text-center',
        // },
        {
          key: 'date_time',
          label: 'วันเวลา',
          class: 'text-center',
        },
        {
          key: 'filepath',
          label: 'ภาพเหตุการณ์',
          class: 'text-center',
        },
        {
          key: 'incident_type',
          label: 'เหตุการณ์',
          class: 'text-center',
        },
        // {
        //   key: 'STA',
        //   label: 'จุดติดตั้ง',
        //   class: 'text-center',
        // },
        // {
        //   key: 'camid',
        //   label: 'กล้องที่',
        //   class: 'text-center',
        // },
        {
          key: 'live',
          label: 'รายละเอียด',
          class: 'text-center',
        },
      ],
      date: {
        wid: '',
        dateFrom: '',
        dateTo: '',
        month: new Date().getFullYear(),
        year: 1,
      },
      // event_status: [{
      //   down: 'Down ⬇', up: '⬆ Up',
      // },
      // {
      //   down: 'danger', up: 'success',
      // }],
    }
  },
  computed: {
    Items() {
      return this.items.slice(0, 3)
    },
    // filteredItems() {
    //   const currentDate = new Date()
    //   currentDate.setHours(0, 0, 0, 0) // Set to midnight for accurate comparison

    //   return this.items.filter(item => {
    //     const itemDate = new Date(item.date) // Assuming 'date' is the key in your items
    //     return itemDate < currentDate // Filters out today's date
    //   })
    // },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.date.wid = this.$route.query.wid
    this.setToday()
    this.getSemEvent()
    this.interval = setInterval(() => {
      this.getSemEvent()
    }, 10000)
  },
  methods: {
    getSemEvent() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getTableIncident-G', this.date)
          .then(response => {
            this.items = response.data
            this.totalRows = response.data.length
            this.camid = response.data.camid
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getTableIncident', this.date)
          .then(response => {
            this.items = response.data
            this.totalRows = response.data.length
            this.camid = response.data.camid
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    setToday() {
      const today = new Date()
      const pastDate = new Date(today)
      pastDate.setDate(today.getDate() - 10)

      const formatDate = date => {
        const month = (`0${date.getMonth() + 1}`).slice(-2)
        const year = date.getFullYear()
        const dateTo = (`0${date.getDate()}`).slice(-2)
        return `${year}-${month}-${dateTo}`
      }

      this.date.dateFrom = formatDate(pastDate)
      this.date.dateTo = formatDate(today)
    },
    // getSemEvent() {
    //   if (this.$route.query.type !== '0') {
    //     axios
    //       .post('/getEventImgAIDetail-G', { wid: this.$route.query.wid })
    //       .then(response => {
    //         this.items = response.data
    //         this.totalRows = response.data.length
    //         this.camid = response.data.CAMID
    //       })
    //       .catch(error => {
    //         console.log(error)
    //       })
    //   } else {
    //     axios
    //       .post('/getEventImgAIDetail', { wid: this.$route.query.wid })
    //       .then(response => {
    //         this.items = response.data
    //         this.totalRows = response.data.length
    //         this.camid = response.data.CAMID
    //       })
    //       .catch(error => {
    //         console.log(error)
    //       })
    //   }
    // },
    showImg(img) {
      this.$swal({
        imageUrl: img,
        imageAlt: 'Custom image',
        width: 800,
        background: 'hsla(0, 100%, 100%, 0)',
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
      })
    },

  },
}
</script>
<style lang="scss">
.hidden_header {
  display: none;
}
.table-responsive{
   font-size: 14px;
}
.table th{
   padding: 0.72rem;
}
.table td{
   padding: 0.72rem;
}

.custom-table {
  background: linear-gradient(to right, rgba(0, 195, 255, 0.6), rgba(39, 115, 138, 0.4));
}
.custom-table .table {
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
}

.table-container {
  overflow: hidden;
  position: relative;
  height: 510px; /* Adjust the height as needed */
}

.scroll-wrapper {
  display: flex;
  flex-direction: column;
  animation: scroll 15s linear infinite;
}

@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-50%);
  }
  100% {
    transform: translateY(-50%);
  }
}

.custom-table.clone {
  margin-top: 0; /* Ensures the cloned table starts right after the original */
}
// #table-container {
//   // display: inline-block;
//   animation: scroll 5s linear infinite;

//    @keyframes scroll {
//   0% {
//     transform: translateX(100%);
//   }
//   100% {
//     transform: translateX(-100%);
//   }
//   }
// }
</style>
